import { use } from 'react';

import { ThemeContext, type ThemeContextValue } from './ThemeContext';

/**
 * Reads and changes the theme.
 *
 * @returns the theme state
 * @throws Error when used outside a ThemeProvider, which is a wiring mistake
 *     rather than a runtime condition worth handling
 */
export function useTheme(): ThemeContextValue {
  const value = use(ThemeContext);
  if (value === null) {
    throw new Error('useTheme must be called inside a ThemeProvider');
  }
  return value;
}
